<template>
  <div>
    <g-breadcrumb :paginas="paginaStatus.caminhoMigalha" />
    <g-pesquisa
      id="refPesquisa"
      name="refPesquisa"
      ref="refPesquisa"
      :filtroAdicional="getFiltroPesquisa"
      :limparFiltroLocal="limparFiltro"
      :colunasPropriedade=colunas
      :apiPesquisa="apiSubAssunto"
      :operacoes="operacoes"
      :exibirColunaOperacoes="exibirColunaOperacoes"
      :elementosPorPagina="elementosPorPagina"
      :novo="cadastrarItem"
      :imprimir="imprimir"
      :showTermoPesquisa="false"
      :carregamentoInicial="false"
      :showBuscaAvancadaAberta="true"
      :showBotaoNovo="permissaoPerfil.incluir"
    >

      <div class="row">
        <div class="col-sm-12 col-xs-12">
          <g-input
            id="refDescricao"
            name="refDescricao"
            ref="refDescricao"
            tipo="text"
            etiqueta="Descrição"
            :foco="false"
            :tamanho="100"
            :chamarFuncaoNoEnter="pesquisarPrimeiraPagina"
            v-model="subAssunto.desSubassunto"
          >
          </g-input>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-xs-12">
          <g-autocomplete
            id="refAssunto"
            name="refAssunto"
            ref="refAssunto"
            etiqueta="Assunto"
            valor="codAssunto"
            descricaoPrimaria="desAssunto"
            :desabilitar="paginaStatus.desabilitarEdicao"
            :api=apiAssunto
            v-model="subAssunto.assunto.codAssunto"
          >
          </g-autocomplete>
        </div>
      </div>
      <br />
    </g-pesquisa>
  </div>
</template>

<script>

import utilHttp from 'components/util/utilHttp'
import msg from 'components/util/msg'
import GBreadcrumb from 'components/util/gBreadcrumb'
import GInput from 'components/util/gInput'
import GSelect from 'components/util/gSelect'
import GPesquisa from 'components/util/gPesquisa'
import GAutocomplete from 'components/util/gAutocomplete'
import constante from 'components/util/constante'

import api from 'components/util/api'

import util from 'components/util/util'
// import utilHttp from 'components/util/utilHttp'
export default {

  data () {
    return {
      pagina: 1,
      elementosPorPagina: 10,
      permissaoPerfil: '',
      apiAssunto: api.ASSUNTO,
      apiSubAssunto: api.SUB_ASSUNTO,
      exibirColunaOperacoes: true,
      subAssunto: { assunto: {} },
      paginaStatus: {
        subAssunto: {
          assunto: {}
        },
        desabilitarEdicao: false,
        caminhoMigalha: [
          {
            icone: '',
            descricao: '',
            rotaNome: ''
          }
        ]
      },
      colunas: [
        {
          conteudoTipo: '',
          largura: '38%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Descrição',
          conteudoClasse: 'text-left',
          propriedade: 'desSubassunto'
        },
        {
          conteudoTipo: '',
          largura: '33%',
          cabecalhoClasse: 'text-left',
          cabecalhoEtiqueta: 'Assunto',
          conteudoClasse: 'text-left',
          propriedade: 'assunto.desAssunto'
        },
        {
          conteudoTipo: 'badge',
          propriedade: 'indVisivelPortal',
          cabecalhoEtiqueta: 'Visível no Portal',
          cabecalhoClasse: 'text-center',
          conteudoClasse: 'text-center',
          largura: '10%',
          arrayOpcoes: constante.ATIVO_ENUM
        },
        {
          conteudoTipo: 'badge',
          propriedade: 'indAtivo',
          cabecalhoEtiqueta: 'Ativo',
          cabecalhoClasse: 'text-center',
          conteudoClasse: 'text-center',
          largura: '5%',
          arrayOpcoes: constante.ATIVO_ENUM
        }

      ],
      operacoes: [
        {
          cor: 'blue',
          icone: 'fas fa-search',
          tooltip: 'Visualizar Subassunto',
          clique: this.visualizarItem,
          permissao: (row) => true,
          visivel: (row) => true
        },
        {
          cor: 'orange',
          icone: 'fas fa-edit',
          tooltip: 'Editar  Subassunto',
          clique: this.editarItem,
          permissao: (row) => this.permissaoPerfil.alterar,
          visivel: (row) => this.permissaoPerfil.alterar
        },
        {
          cor: 'red',
          icone: 'fas fa-trash',
          tooltip: 'Excluir  Subassunto',
          clique: this.excluirItem,
          permissao: (row) => this.permissaoPerfil.excluir,
          visivel: (row) => this.permissaoPerfil.excluir
        }
      ]

    }
  },
  methods: {
    limparFiltro () {
      this.subAssunto = {
        assunto: {}
      }
      this.$refs['refAssunto'].limpar()
    },
    imprimir () {
      util.exibirToastInfo(msg.m(12))
    },
    excluirItem (item) {
      util.exibirConfirmacaoExclusao('EXCLUIR', msg.m(5), () => {
        var filtro = '/'.concat(item.codSubassunto)

        utilHttp.httpDeletePorID(api.SUB_ASSUNTO.concat(filtro), resposta => {
          util.exibirToastSucesso(msg.m(4))
          this.pesquisarPrimeiraPagina()
        })
      })
    },
    visualizarItem (item) {
      this.paginaStatus.subAssunto = item
      this.paginaStatus.desabilitarEdicao = true
      this.paginaStatus.operacao = {
        descricao: 'Visualizar Subassunto',
        icone: 'fa fa-search'
      }
      this.$router.push({
        name: 'subAssunto',
        params: {
          paginaStatus: this.paginaStatus
        }
      })
    },
    editarItem (item) {
      this.paginaStatus.subAssunto = item
      this.paginaStatus.desabilitarEdicao = false
      this.paginaStatus.operacao = {
        descricao: 'Editar Subassunto',
        icone: 'fa fa-edit'
      }
      this.$router.push({
        name: 'subAssunto',
        params: {
          paginaStatus: this.paginaStatus
        }
      })
    },
    getFiltroPesquisa () {
      var filtro = ''
      var self = this
      if (self.subAssunto.desSubassunto) filtro = filtro.concat('&desSubassunto=').concat(self.subAssunto.desSubassunto)
      if (self.subAssunto.assunto.codAssunto) filtro = filtro.concat('&codAssunto=').concat(self.subAssunto.assunto.codAssunto)
      return filtro
    },
    cadastrarItem () {
      this.paginaStatus.operacao = {
        descricao: 'Novo',
        icone: 'fa fa-plus'
      }
      this.$router.push({
        name: 'subAssunto',
        params: {
          paginaStatus: this.paginaStatus
        }
      })
    },
    pesquisarPrimeiraPagina () {
      this.$refs['refPesquisa'].pesquisar()
    }
  },
  watch: {
    paginaStatus: {
      handler (valor) {
        if (valor) {
          util.adicionarNoStorage(this.chaveLocalStorage, valor)
        } else util.removerDoStorage(this.chaveLocalStorage)
      },
      deep: true
    }
  },
  mounted () {
    this.paginaStatus.caminhoMigalha = [
      {
        icone: 'fas fa-folder-open',
        descricao: 'Subassunto',
        rotaNome: 'SubAssuntoPesquisa'
      }
    ]
    // this.pesquisarPrimeiraPagina()
    this.permissaoPerfil = util.montarPermissoes(this.$router.history.current.path)
  },
  components: { GBreadcrumb, GInput, GSelect, GPesquisa, GAutocomplete }
}
</script>
